(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.controller('ShadowItAppsController', ["$scope", "securityEventStates", "securityEventTypes", "tablePaginationHelper", "securityEventsDao", "defaultListConverter", "$location", "base64", "timeResolutions", "securityEventsConverters", "securityEventsLinkGenerator", "feature", function ($scope, securityEventStates, securityEventTypes, tablePaginationHelper, securityEventsDao, defaultListConverter, $location, base64, timeResolutions, securityEventsConverters, securityEventsLinkGenerator, feature) {
        $scope.model = {};
        var defaultLabel = 'Shadow IT Applications';
        if (feature.sonicwallTheme) {
            defaultLabel = 'Shadow SaaS Applications';
        }
        $scope.pageTitle = defaultLabel;
        var filters = [
            {
                id: 'new',
                type: 'current_state'
            },
            {
                id: 'remediated',
                type: 'current_state'
            }
        ];
        $scope.options = {
            columns: [
                {
                    id: 'app-logo',
                    text: false,
                    converter: function (text, columnId, row) {
                        return '#' + JSON.stringify({
                            display: 'img',
                            path: '//logo.clearbit.com/' + row.shadow_it_application,
                            defaultPath: 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='    // transparent 1 pixel gif
                        });
                    }
                },
                {
                    id: 'shadow_it_application',
                    text: 'Application',
                    primary: true,
                    sortable: true
                },
                {
                    id: 'risk_level',
                    text: 'Risk Level',
                    converter: securityEventsConverters.severityConverter,
                    sortable: true
                },
                {
                    id: 'av_category',
                    text: 'Category',
                    sortable: true
                },
                {
                    id: 'events_count',
                    text: 'Events',
                    sortable: true
                },
                {
                    id: 'users_count',
                    text: 'Users',
                    sortable: true
                },
                {
                    id: 'min_time',
                    text: 'First used time',
                    format: 'time',
                    sortable: true
                },
                {
                    id: 'max_time',
                    text: 'Last used time',
                    format: 'time',
                    sortable: true
                }
            ],
            options: {
                defaultOrdering: {
                    columnName: 'shadow_it_application',
                    order: 'asc'
                },
                autoUpdate: 60000,
                lineSelection: true,
                singleSelection: true
            }
        };
        var resolution = null;
        function processUrlFilters() {
            $scope.label = defaultLabel;
            resolution = timeResolutions.get($location.search().resolution);
            var category = $location.search().category;
            var risk_level = $location.search().risk_level;
            var states = $location.search().states;
            var saas = $location.search().saas;
            if (category) {
                filters = _(filters).filter(function (filter) {
                    return filter.type !== 'av_category';
                }).concat([{
                        id: category,
                        type: 'av_category'
                    }]);
                $scope.label = category + ' ' + $scope.label;
            }
            if (risk_level) {
                filters = _(filters).filter(function (filter) {
                    return filter.type !== 'risk_level';
                }).concat([{
                        id: risk_level,
                        type: 'risk_level'
                    }]);
                $scope.label = $scope.label + ' with Risk Level ' + risk_level;
            }
            if (states) {
                filters = _(filters).filter(function (filter) {
                    return filter.type !== 'current_state';
                }).concat(_(states.split(',')).map(function (state) {
                    return {
                        id: state,
                        type: 'current_state'
                    };
                }));
            }
            if (saas) {
                filters = _(filters).filter(function (filter) {
                    return filter.type !== 'saas';
                }).concat(_(saas.split(',')).map(function (item) {
                    return {
                        id: item,
                        type: 'saas'
                    };
                }));
            }
        }
        processUrlFilters();
        $scope.tableOptions = {
            disableTop: true,
            orderDisplayMode: 'highlight-column',
            asDivs: true,
            infinite: true,
            reloadUuid: true,
            showWorkingIndicator: true,
            workingIndicatorDisableGui: false,
            saveState: true,
            pagesAround: 2,
            pagination: {
                pageSize: 20,
                ordering: {}
            },
            dropdownHeader: true
        };
        $scope.tableHelper = tablePaginationHelper($scope, $scope.tableOptions, $scope.options, function (args) {
            var result = securityEventsDao.shadowItApps();
            result.params(_(filters).chain().reduce(function (memo, filter) {
                var type = 'filterEnum_' + filter.type;
                memo[type] = memo[type] || [];
                memo[type].push(filter.id);
                return memo;
            }, {}).mapObject(function (val) {
                return val.join(',');
            }).value());
            if (resolution) {
                result.params({
                    afterColumn: 'create_time',
                    afterStep: resolution.id,
                    afterFromNow: true,
                    afterMax: 1
                });
            }
            return result.pagination(args.offset, args.limit).order(args.ordering.columnName, args.ordering.order).converter(defaultListConverter, function (preFetches) {
                return { columns: $scope.options.columns };
            });
        }, function (tableModel) {
            $scope.tableModel = tableModel;
        });
        $scope.$watchCollection(function () {
            return $scope.tableHelper ? $scope.tableHelper.getSelectedIds() : [];
        }, function (newValue) {
            if (newValue && newValue.length === 1) {
                var params = {
                    shadow_it_application: [newValue[0]],
                    type: ['shadow_it']
                };
                _(filters).each(function (filter) {
                    if (filter.type === 'saas' || filter.type === 'current_state') {
                        params[filter.type] = params[filter.type] || [];
                        params[filter.type].push(filter.id);
                    }
                });
                if (resolution) {
                    params.resolution = resolution.id;
                }
                $location.url(securityEventsLinkGenerator.createPath(params));
            }
        });
    }]);
}());